import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    'Supabase: REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY must be set in .env'
  );
}

// No-op lock avoids Navigator LockManager timeout when multiple tabs or React Strict Mode
// cause lock contention. Auth still works; we skip cross-tab lock coordination.
const noOpLock = async (_name, _acquireTimeout, fn) => fn();

export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    lock: noOpLock,
  },
});

const WAKE_UP_TIMEOUT_MS = 5000;

/**
 * Run a lightweight query to wake up the Supabase connection after tab was backgrounded.
 * Call before fetch/insert/update when the tab may have been hidden. Same pattern as DepartmentsTest.
 */
export async function runSupabaseWakeUp() {
  return Promise.race([
    supabase.from('profiles').select('id').limit(1),
    new Promise((_, reject) =>
      setTimeout(() => reject(new Error('wakeup_timeout')), WAKE_UP_TIMEOUT_MS)
    ),
  ]).catch(() => {});
}

/**
 * Same order as DepartmentsTest: refresh session then wake up. Call before any fetch when tab may have been backgrounded.
 */
export async function refreshSessionAndWakeUp() {
  await supabase.auth.getSession();
  await runSupabaseWakeUp();
}
